import React, { FC, useEffect } from "react";
import { NoticeAdHeader } from "./components/NoticeAdHeader";
import { DefaultDashboardScreen } from "./components/DefaultDashboardScreen";
import "./index.scss";
import { RequestsDashboard } from "./components/RequestsDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllRaiseAdRequest,
  getUserWorkspaceRoleAction,
} from "../../store/actions/raiseAdRequest";
import { useParams } from "react-router-dom";
import { RaiseAdRequestState } from "../../store/types/raiseAdRequest";
import { FullScreenSpinner } from "../../components/shared/Spinner";

export const RaiseNoticeAdRequest: FC = () => {
  const dispatch = useDispatch();
  const { allRequests,loading } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );
  const { selectedProductId } = useParams<{ selectedProductId: string }>();
  useEffect(() => {
    dispatch(fetchAllRaiseAdRequest({ productId: selectedProductId }));
    dispatch(getUserWorkspaceRoleAction(selectedProductId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
    {loading && <FullScreenSpinner />}
      <NoticeAdHeader />

      {allRequests.count ? (
        <RequestsDashboard />
      ) : (
        // Screen when there is no request raised
        <div className="raise-notice-ad-request">
          <DefaultDashboardScreen />
        </div>
      )}
    </>
  );
};
